// Navigation-experience Sentry DSN
export const SENTRY_DSN =
	'https://b8c4ebbdd822beb92561fea2a46d2146@o55978.ingest.us.sentry.io/4510463033081856';

export const SENTRY_TEAM_NAME = 'afe-navigation-experience';

export const DEFAULT_SENTRY_CONFIG: {
	attachStacktrace: boolean;
	ignoreErrors: RegExp[];
	ignoreUrls: RegExp[];
	whitelistUrls: RegExp[];
} = {
	whitelistUrls: [/atl-paas.net/, /localhost/],
	ignoreErrors: [/^SentryIgnore:/],
	ignoreUrls: [/extensions\//i, /^chrome:\/\//i],
	attachStacktrace: true,
};

export const SENTRY_PRODUCT = 'navigation';
